<template>
  <div class="p-base" style="background-color: #ffffff">
    
    <!-- Top Section (Upper): Title & Visibility -->
    <div class="vx-row" style="margin-bottom: 40px">
      <!-- Board Title -->
      <div class="vx-col w-full md:w-1/2 sm:pr-4 mb-6 md:mb-0">
        <h3 class="mb-3">Board Title</h3>
        <vs-input
          required
          class="w-full board-name"
          v-model="localData.title"
        />
      </div>

      <!-- User Visibility Option -->
      <div class="vx-col w-full md:w-1/2 sm:pl-4">
        <h3 class="mb-3">User visibility option</h3>
        <v-select
          placeholder="People on the board"
          :options="userVisibility"
          v-model="userVisibilityOption"
        >
        </v-select>
      </div>
    </div>

    <!-- Middle Section (Lower): Skills & Personality -->
    <div class="vx-row" style="margin-bottom: 40px">
      <!-- Skills -->
      <div class="vx-col w-full md:w-1/2 sm:pr-4 mb-6 md:mb-0">
        <h3 class="mb-3">Skills</h3>
        <v-select
          class="w-full mb-4 vselect"
          name="Skill"
          :taggable="true"
          v-model="setSkill"
          :options="skillOptions"
        />
        <div>
          <vs-chip
            class="mr-3 mt-2"
            @click="removeSkill(index)"
            v-for="(chip, index) in localData.skill"
            :key="index"
            closable
          >
            <p class="text-dark">{{ chip }}</p>
          </vs-chip>
        </div>
      </div>

      <!-- Personality -->
      <div class="vx-col w-full md:w-1/2 sm:pl-4">
        <h3 class="mb-3">Personality</h3>
        <v-select
          class="w-full mb-4 vselect"
          name="Personality"
          :taggable="true"
          v-model="setPersonality"
          :options="personalityOptions"
        />
        <div>
          <vs-chip
            class="mr-3 mt-2"
            @click="removePersonality(index)"
            v-for="(chip, index) in localData.personality"
            :key="index"
            closable
          >
            <p class="text-dark">{{ chip }}</p>
          </vs-chip>
        </div>
      </div>
    </div>

    <!-- Bottom Section: Description Full Width -->
    <div class="vx-row">
      <!-- Description Editor -->
      <div class="vx-col w-full" style="margin-bottom: 40px;">
        <h3 class="mb-3">Description</h3>
        <div>
          <quill-editor
            class="quill-editor"
            ref="myTextEditor"
            :value="localData.description"
            :options="editorOption"
            @change="onEditorChange"
          />
        </div>
      </div>

      <!-- Action Button -->
      <div class="vx-col w-full flex justify-end" style="margin-top: 30px; margin-bottom: 30px;">
        <vs-button
          size="large"
          class="w-full sm:w-auto px-10 py-3 text-lg shadow-md"
          @click.prevent="updateBoard"
          :disabled="!currentBoardDetails.title"
        >
          Update Board
        </vs-button>
      </div>
    </div>

  </div>
</template>

<script>
import boardTemplates from "@/assets/data/board-templates.js";
import marketplaceList from "@/assets/data/marketplace-list.js";
import _ from "lodash";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import allSkills from "@/assets/data/all-skills.js";
import allPersonality from "@/assets/data/all-personality.js";
import vSelect from "vue-select";
import axios from "axios";

export default {
  data() {
    return {
      realBoardId: null,
      boardTemplates,
      marketplaceList,
      localData: {},
      appsOnBoard: [],
      priceDetails: {
        totalPricePerUser: 0,
        discount: 0,
        specialDiscount: 2,
        taxPerUser: 1,
        emiEligibility: false,
      },
      transactions: [],
      addFundsForm: false,
      currency: "eur",
      boardDescription: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"],
          ],
        },
      },
      skillOptions: allSkills,
      personalityOptions: allPersonality,
      addedNumberOfUsers: 0,
      addedNumberOfMonths: 0,
      appPrices: {},
      userVisibility: [
        {
          label: "Cannot see other people",
          key: "noUsersView",
          description: "Don't show who's on board",
        },
        {
          label: "Can see names and thumbnail",
          key: "usersDpView",
          description: "Show name and thumbnail on board of other users",
        },
        {
          label: "Can view profile cards",
          key: "talentCardView",
          description: "Show only profile card but no contact links",
        },
        {
          label: "Can view full profile",
          key: "resumeView",
          description: "Show contact links as well as the resume link",
        },
      ],
      userVisibilityOption: [],
      addedApps: [],
    };
  },
  components: {
    quillEditor,
    vSelect,
  },
  computed: {
    _boardId() {
      // Prioritize the resolved MongoDB ID if we mapped it from MySQL, else fallback to route param
      return this.realBoardId || this.$route.params.boardId;
    },
    boardId() {
      return this.$store.state.boards.boardCreation.boardId;
    },
    currentBoardTemplate() {
      const boardIndex = this.boardTemplates.findIndex((board) => {
        return board.id === this.boardId;
      });
      if (boardIndex !== -1) return this.boardTemplates[boardIndex];
      else return this.boardTemplates[0];
    },
    currentBoardDetails() {
      return this.$store.state.boards.boardCreation;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    userData() {
      return this.$store.state.users.data;
    },
    setSkill: {
      get() {
        return null;
      },
      set(newVal) {
        if (this.localData.skill && this.localData.skill.includes(newVal)) {
          return;
        }
        if (this.localData.skill && this.localData.skill.length) {
          this.localData.skill.push(newVal);
        } else {
          this.localData.skill = [];
          this.localData.skill.push(newVal);
        }

        this.$forceUpdate();
      },
    },
    setPersonality: {
      get() {
        return null;
      },
      set(newVal) {
        if (
          this.localData.personality &&
          this.localData.personality.includes(newVal)
        ) {
          return;
        }

        if (this.localData.personality && this.localData.personality.length) {
          this.localData.personality.push(newVal);
        } else {
          this.localData.personality = [];
          this.localData.personality.push(newVal);
        }

        this.$forceUpdate();
      },
    },
    availableBalance() {
      return this.$store.state.payments.availableFunds;
    },
    allApps() {
      return [...this.localData.installedApps, ...this.addedApps];
    },
  },
  watch: {
    currentBoardDetails(newVal) {
      if (newVal) {
        this.localData = JSON.parse(JSON.stringify(this.currentBoardDetails));

        this.$store.dispatch("payments/fetchAppPrice").then((res) => {
          this.appPrices = res.data;
        });

        const payload = {
          appIds: newVal.installedApps,
          numberOfUsers: newVal.numberOfUsers,
          numberOfMonths: newVal.numberOfMonths,
          timePeriodMovement: "ceil",
        };

        this.$store
          .dispatch("payments/fetchBoardPrice", payload)
          .then((res2) => {
            this.priceDetails.previousAmount = res2.data.netPrice;
          });

        if (!this.localData.skill) {
          this.localData.skill = [];
        }
        if (!this.localData.personality) {
          this.localData.personality = [];
        }
      }
    },
    addedNumberOfMonths() {
      this.setPricing();
    },
    localData: {
      deep: true,
      handler() {
        this.setPricing();
      },
    },
    orgData(newVal) {
      if (newVal && newVal._id) {
        this.$store.dispatch("payments/fetchFunds", {
          organizationId: newVal._id,
        });
      }
    },
    addedNumberOfUsers() {
      this.setPricing();
    },
    addedApps() {
      this.setPricing();
    },
  },
  methods: {
    generateBoardSlug(boardTitle) {
      let slug = "default";
      if (boardTitle) {
        let r = (Math.random() + 1).toString(36).substring(3);
        slug =
          boardTitle
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "-" +
          r;
      }
      return slug;
    },
    verifyNumberOfUsers() {
      if (
        this.localData.numberOfUsers < this.currentBoardDetails.numberOfUsers
      ) {
        this.localData.numberOfUsers = this.currentBoardDetails.numberOfUsers;
      }
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    updateBoard() {
      if (!this.localData.title || !this.orgData._id) return;

      // verify number of users
      this.verifyNumberOfUsers();

      const payload = {
        title: this.localData.title,
        numberOfUsers:
          Number(this.localData.numberOfUsers) +
          Number(this.addedNumberOfUsers),
        _boardId: this._boardId,
        installedApps: this.allApps,
        description: this.localData.description,
        createBoardPaymentSession: false,
        skill: this.localData.skill,
        personality: this.localData.personality,
        userVisibilityOption: this.userVisibilityOption.key,
      };

      if (this.addedNumberOfUsers > 0) {
        if (this.priceDetails.netMRP > 0) {
          this.$store.dispatch("payments/createTransaction", {
            organizationId: this.orgData._id,
            userId: this.userData._id,
            amount: this.priceDetails.netMRP,
            currency: "eur",
            boardId: this._boardId,
            fundType: "DEBIT",
            remark: `Add Credits to ${this.boardName} Board`,
            deductFund: true,
            details: {
              numberOfUsers: this.addedNumberOfUsers,
              numberOfMonths: this.numberOfMonths,
              ...this.priceDetails,
            },
            transactionType: "BOARD_TRANSACTION",
          });
        }

        this.$store.dispatch("payments/addCreditsToBoard", {
          organizationId: this.orgData._id,
          userId: this.userData._id,
          boardId: this._boardId,
          credits: this.addedNumberOfUsers,
        });
      }

      this.$store
        .dispatch("boards/updateBoard", {
          boardObj: payload,
          organizationId: this.orgData._id,
        })
        .then((res) => {
          this.$router.push({ name: "org-boards-view" });
        })
        .catch((err) => {
          throw err;
        });
    },
    onEditorChange: _.debounce(function (value) {
      this.localData.description = value.html;
    }, 466),
    setPricing(params) {
      if (
        (this.addedNumberOfUsers && this.addedNumberOfUsers > 0) ||
        (this.addedApps && this.addedApps.length > 0) ||
        this.addedNumberOfMonths > 0
      ) {
        let timePeriodMovement = "ceil";
        if (params && params.timePeriodMovement === "floor") {
          timePeriodMovement = "floor";
        }

        const payload = {
          defaultApps: this.currentBoardDetails.installedApps,
          appIds:
            this.addedApps && Object.keys(this.addedApps).length
              ? this.addedApps
              : this.currentBoardDetails.installedApps,
          numberOfUsers:
            this.addedApps && Object.keys(this.addedApps).length
              ? Number(this.addedNumberOfUsers) +
                Number(this.currentBoardDetails.numberOfUsers)
              : Number(this.addedNumberOfUsers),
          numberOfMonths: this.addedNumberOfMonths,
          timePeriodMovement: timePeriodMovement,
        };

        if (!this.addedNumberOfMonths) {
          payload.numberOfMonths = this.currentBoardDetails.numberOfMonths
            ? this.currentBoardDetails.numberOfMonths
            : 1;
        }

        this.$store
          .dispatch("payments/fetchBoardPrice", payload)
          .then((res) => {
            this.priceDetails.totalPricePerUser = (
              Number(res.data.totalPrice) / Number(payload.numberOfUsers)
            ).toFixed(2);
            this.priceDetails.totalMRP = res.data.totalPrice;
            this.priceDetails.totalDiscount = res.data.discount;
            this.priceDetails.totalTax = res.data.taxAmount;
            this.priceDetails.netMRP = Number(res.data.netPrice).toFixed(2);
            this.$forceUpdate();
            if (this.addedNumberOfMonths) {
              this.addedNumberOfMonths = res.data.minimumTimePeriodInMonths;
            }
          });
      } else {
        this.localData.addedNumberOfUsers = 0;
        this.priceDetails.totalPricePerUser = 0;
        this.priceDetails.totalMRP = 0;
        this.priceDetails.totalDiscount = 0;
        this.priceDetails.totalTax = 0;
        this.priceDetails.netMRP = 0;
      }
    },
    removeSkill(index) {
      this.localData.skill.splice(index, 1);
      this.$forceUpdate();
    },
    removePersonality(index) {
      this.localData.personality.splice(index, 1);
      this.$forceUpdate();
    },
  },
  async created() {
    let routeId = this.$route.params.boardId;
    this.realBoardId = routeId; // Default to route ID

    // INTERCEPT: If the ID is a short MySQL ID (e.g., 23) instead of a 24-char MongoDB ID
    if (routeId && String(routeId).length < 24) {
      this.$vs.loading();
      try {
        const orgId = this.$store.state.organization.orgData._id;
        const pythonApiUrl = process.env.VUE_APP_API_URL;
        
        // Fetch org plans to find the corresponding board_id mapping
        const plansRes = await axios.get(`${pythonApiUrl}/api/v2/coach-plans/${orgId}`);
        
        if (plansRes.data && plansRes.data.data) {
          // Find the row where the MySQL `id` matches our route param
          const matchedPlan = plansRes.data.data.find(p => String(p.id) === String(routeId));
          
          if (matchedPlan && matchedPlan.board_id) {
            this.realBoardId = matchedPlan.board_id; // Set to actual MongoDB ID (e.g. 6a47...)
            
            // Silently correct the URL in the browser address bar
            this.$router.replace({ 
              params: { ...this.$route.params, boardId: this.realBoardId } 
            });
          }
        }
      } catch (err) {
        console.warn("Could not map MySQL plan ID to Mongo board ID", err);
      } finally {
        this.$vs.loading.close();
      }
    }

    // Now proceed with the Correct ID (this._boardId)
    this.$store
      .dispatch("boards/fetchBoardDetails", this._boardId)
      .then((res) => {
        if (res && res.data && res.data.userVisibilityOption) {
          let obj = this.userVisibility.find(
            (obj) => obj.key === res.data.userVisibilityOption
          );
          this.userVisibilityOption = obj;
        }

        const payload = {
          appIds: res.data.installedApps,
          numberOfUsers: res.data.numberOfUsers,
          numberOfMonths: res.data.numberOfMonths,
          timePeriodMovement: "ceil",
        };

        this.$store
          .dispatch("payments/fetchBoardPrice", payload)
          .then((res2) => {
            this.priceDetails.previousAmount = res2.data.netPrice;
          });
      })
      .catch((err) => {
        console.error("Error fetching board details:", err);
      });

    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("payments/fetchFunds", {
        organizationId: this.orgData._id,
      });
    }

    this.$store
      .dispatch("payments/fetchAppPrice")
      .then((res) => {
        this.appPrices = res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  beforeDestroy() {
    this.localData = {};
  },
};
</script>

<style scoped>
.nou-input.vs-input-number {
  background-color: #ffffff !important;
}

.nou-input.vs-input-number >>> input {
  font-size: 15px;
}

.nou-input.vs-input-number >>> button {
  border-radius: 5px !important;
}

button {
  border-radius: 8px !important;
}

.board-name >>> .vs-con-input input.vs-input--input {
  font-size: 25px !important;
}

.vs-con-textarea {
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  box-sizing: border-box;
  border-radius: 6px;
  height: 175px;

  font-weight: normal;
  font-size: 1rem;
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;

  margin-bottom: 0;

  display: flex;
  flex-direction: column;
}

.vs-con-textarea .vs-textarea {
  background: #fbfbfc;
  box-sizing: border-box;
  border-radius: 6px;
  height: 175px;

  font-weight: normal;
  font-size: 1rem;
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;
}

.vs-con-textarea >>> .vs-textarea {
  height: 175px !important;
}

.quill-editor {
  height: 15rem;
}
</style>